import { Box, Container,  Stack,  Text, ThemeIcon } from '@mantine/core'
import { headerStyles } from './Header.styles'
import { BrandIcon } from '../BrandIcon'
import { IconMail, IconMapPin, IconPhone, IconClock } from '@tabler/icons-react'
import { useStorageContext } from '@/contexts/StorageContext'

export function Header() {
  const storage = useStorageContext()

  return (
    <Box style={headerStyles.container}>
        <Container size="md" style={headerStyles.inner}>
        <BrandIcon 
          size={180}
          color="#ffffff"
          style={headerStyles.logo}
        />
        <div style={headerStyles.contactItem}>


<Stack gap="0">
  <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
    <ThemeIcon size="sm" variant="subtle" color="green">
      <IconPhone size={16} />
    </ThemeIcon>
    <Stack gap={0}>
      <Text size="sm" fw={500}>{storage.barndInfo.phone}</Text>
    </Stack>
  </Box>

  <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
    <ThemeIcon size="sm" variant="subtle" color="blue">
      <IconMail size={16} />
    </ThemeIcon>
    <Text size="sm" c="dimmed">{storage.barndInfo.email}</Text>
  </Box>

  <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
    <ThemeIcon size="sm" variant="subtle" color="orange">
      <IconMapPin size={16} />
    </ThemeIcon>
    <Text size="sm" c="dimmed">
    {storage.barndInfo.address}
    </Text>
  </Box>

  <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
    <ThemeIcon size="sm" variant="subtle" color="violet">
      <IconClock size={16} />
    </ThemeIcon>
    <Stack gap={0}>
    <Text size="sm" c="dimmed">Пн-Сб: 9:00 - 18:00</Text>
    <Text size="sm" c="dimmed">Вс: выходной</Text>
    </Stack>
  </Box>
  <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--mantine-spacing-xs)' }}>
    <ThemeIcon size="sm" variant="subtle" color="violet">
      <IconMapPin size={16} />
    </ThemeIcon>
    <Text size="sm" c="dimmed">
    {storage.barndInfo.gps}
    </Text>
  </Box>
</Stack>

        </div>
        </Container>
     
    </Box>
  )
}